export default __webpack_public_path__ + "static/media/logoGrande.8aa81368.png";